module.exports = __webpack_public_path__ + "static/img/son2_active.b6aefafd.png";